<form>
	<div class="row">
		<div class="col">
			<mat-form-field>
				<mat-label>Endereço</mat-label>
				<input
					matInput
					type="text"
					id="addresstext"
					#addresstext
					name="address"
					[(ngModel)]="location.address"
					#addressInput="ngModel"
					maxlength="80"
					(change)="onChangeLocal($event)"
				/>
			</mat-form-field>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<mat-form-field>
				<mat-label>Raio</mat-label>
				<mat-select [(ngModel)]="location.range" name="range" (selectionChange)="emit()" (change)="emit()">
					<mat-option *ngFor="let r of ranges" [value]="r"> {{ r }} Km </mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</form>
